export default __webpack_public_path__ + "static/media/icon_C.1399d55d.svg";